import React from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import LoginPage from './components/pages/LoginPage';
import MainPage from './components/pages/MainPage';
import { Grid } from './components/layout/styled';

const router = createBrowserRouter([
    {
        path: '/',
        element: <MainPage />,
    },
]);

const App: React.FC = () => {
    return (
        <Grid>
            <RouterProvider router={router} />
        </Grid>
    );
};

export default App;
